export default "__VITE_ASSET__4DEp8G_m__"